/**
 * VM-14b — Kleine wiederverwendbare UI-Bausteine für die Mietverhältnis-Detailansicht.
 * Extrahiert aus TenancyDetail.jsx.
 */

export function KeyFact({ label, value, accent = false }) {
  return (
    <div className="flex flex-col">
      <span className="text-[10px] uppercase tracking-[0.14em] font-semibold text-slate-500">{label}</span>
      <span className={`tabular-nums ${accent ? "text-slate-900 font-semibold text-base" : "text-slate-700 font-medium text-sm"}`}>{value}</span>
    </div>
  );
}

export function Info({ label, value, highlight, "data-testid": testId }) {
  return (
    <div className="bg-white border border-slate-200 rounded-md p-3 shadow-sm" data-testid={testId}>
      <div className="text-[10px] uppercase tracking-wider text-slate-500 font-semibold">{label}</div>
      <div className={`text-sm font-medium mt-1 ${highlight ? "text-slate-900" : "text-slate-700"} tabular-nums`}>{value}</div>
    </div>
  );
}

export function Th({ children, className = "" }) {
  return <th className={`px-3 py-2.5 text-xs font-semibold uppercase tracking-wider text-slate-600 ${className}`}>{children}</th>;
}

export function Td({ children, className = "", colSpan }) {
  return <td colSpan={colSpan} className={`px-3 py-2.5 ${className}`}>{children}</td>;
}

export function F({ label, children, className = "" }) {
  return (
    <div className={className}>
      <label className="text-xs text-slate-700 font-medium">{label}</label>
      <div className="mt-1">{children}</div>
    </div>
  );
}

export function Tile({ label, value, tone = "neutral", testid }) {
  const toneClass = tone === "positive" ? "text-emerald-700" : "text-slate-900";
  return (
    <div className="bg-stone-50 border border-stone-100 rounded-sm px-3 py-2" data-testid={testid}>
      <div className="text-[10px] uppercase tracking-wider text-slate-500">{label}</div>
      <div className={`text-base font-semibold tabular-nums ${toneClass}`}>{value}</div>
    </div>
  );
}

export function StatCard({ label, value, accent }) {
  const cls = accent === "warn" ? "text-rose-700" : accent === "ok" ? "text-emerald-700" : "text-slate-900";
  return (
    <div className="bg-white border border-slate-200 rounded-md p-3">
      <div className="text-[10px] uppercase tracking-wider text-slate-500 font-semibold">{label}</div>
      <div className={`text-xl font-semibold tabular-nums mt-1 ${cls}`}>{value}</div>
    </div>
  );
}
